import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getPersonalClockRecordList: (state) => state.items,
  getPersonalClockRecordListPagination: (state) => state.pagination,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
